const data = {
  cases: [
    {
      url: '/innovation-by-design/2018',
      paramater: 'year',
      setTo: '2018'
    },
    {
      url: '/grant-thornton',
      paramater: 'tag',
      setTo: 'grant-thornton'
    }
  ]
};

export default data;
